import React, { useState, useEffect } from 'react';

import Text from 'components/Text';
import { Column, Row } from 'components/Layout/Grid';
import MissingLettersTable from 'components/Table/MissingLetters';
import { missingLetterModel } from 'components/Table/MissingLetters/models';
import { Button } from 'components/Button';
import { useDispatch, useSelector } from 'react-redux';
import MissingLettersSlider from 'components/MissingLettersSlider';
import editIcon from 'img/edit-icon.svg';
import { ITableModel } from 'components/Table/interface';
import { IMissingLetters } from 'models/MissingLetter';
import store from 'store';
import { IUser } from 'models/User';

const MissingLetters: React.FC = () => {
  const user = useSelector((state: { user: IUser; }) => state.user);
  const dispatch = useDispatch();
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableModel, setTableModel] = useState(missingLetterModel);
  const pageSize = 10;

  const editButtonLabel: ITableModel = {
    noFilter: true,
    label: 'Editar',
    size: 60,
    maxSize: 60,
    isButton: true,
    Component: (item: IMissingLetters) => (
      <Button
        onClick={() =>
          store.dispatch({
            type: 'OPEN_SLIDER',
            data: {
              title: 'Editar carta de falta',
              width: '70',
              content: MissingLettersSlider,
              state: { item, setRefreshTable },
            },
          })
        }
      >
        <img src={editIcon} alt="" />
      </Button>
    ),
  };

  const modelEdit: Array<ITableModel> = [
    ...missingLetterModel,
    editButtonLabel,
  ];

  function checkEnable() {
    if (user === undefined || user.profileType === undefined) return false;
    return (
      user.userType === 'employee' &&
      user.profileType.includes('CC_SAC_SERVICE')
    );
  }

  useEffect(() => {
    setTableModel(checkEnable() ? modelEdit : missingLetterModel);
  }, [user]);

  return (
    <>
      <Row className="w-100 justify-between flex-sm-column">
        <Column>
          <Text size={24} className="color-primary font-bold">
            Consulta de carta de falta
          </Text>
        </Column>
        {checkEnable() && (
          <Column className="align-center justify-end">
            <Row>
              <Button
                className="outline mt-sm-3"
                width="auto"
                onClick={() =>
                  dispatch({
                    type: 'OPEN_SLIDER',
                    data: {
                      title: 'Cadastrar carta de falta',
                      width: '70',
                      content: MissingLettersSlider,
                      state: { item: {}, setRefreshTable },
                    },
                  })
                }
              >
                <Text size={14} className="color-primary font-bold px-1">
                  Cadastrar carta de falta
                </Text>
              </Button>
            </Row>
          </Column>
        )}
      </Row>
      <Column className="w-100 max-w-lg-100 flex-1">
        <MissingLettersTable
          model={tableModel}
          pageSize={pageSize}
          completeBlankSpaces
          refreshTable={refreshTable}
        />
      </Column>
    </>
  );
};

export default MissingLetters;
